import type { CaptureResult } from "posthog-js/dist/module.full.no-external";

const NOISE_PATTERNS = [
  /^ResizeObserver loop/,
  /^Script error\.?$/,
  /Lock was stolen by another request|Lock broken by another request/,
  /runtime\.sendMessage/,
  /__firefox__/,
];

interface ExceptionListItem {
  type?: string;
  value?: string;
}

export function dropNoiseExceptions(result: CaptureResult | null): CaptureResult | null {
  if (!result || result.event !== "$exception") return result;
  const list = result.properties?.$exception_list as ExceptionListItem[] | undefined;
  const first = list?.[0];
  if (!first) return result;
  const value = first.value ?? "";
  if (first.type === "DOMException" && value.startsWith("AbortError:")) return null;
  if (NOISE_PATTERNS.some((pattern) => pattern.test(value))) return null;
  return result;
}
